import React, { useState } from "react";
import { Grid } from "@mui/material";
import ByzCard from "src/components/core-components/ByzCard";
import ByzTitleBox from "src/components/core-components/ByzTitleBox";
import ByzTrackBar from "src/components/core-components/ByzTrackBar/ByzTrackBar";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";

interface VisualAnalogScaleProps {
  t: (key: string) => string;
  handleChange: (key: string, value: any) => void;
}

const VisualAnalogScale: React.FC<VisualAnalogScaleProps> = ({
  t,
  handleChange,
}) => {
  const [score, setScore] = useState<number>(1);

  const handleSliderChange = (val: number) => {
    setScore(val);
    handleChange("VAS_SCALE_SCORE", val); // örnek: dışarıya gönder
  };

  return (
    <ByzCard sx={{ mt: 3, mb: 5 }}>
      <ByzTitleBox title={t("pain-assessment-scale.vizuel-analog-scale.title")} />

      <ByzCard sx={{ padding: 3,pt:5, ml: 1, mb: 1}} >
        <ByzTrackBar
          maxValue={10}
          value={score}
          onChange={handleSliderChange}
          sx={{ width: "50%" }}
        />
      </ByzCard>

      {/* Skor Bilgisi */}
      <ByzCard sx={{ padding: 0, ml: 1, mt: 0 }}>
        <Grid container spacing={2} p={2}>
          <Grid item xs={12} sm={6}>
            <ByzMuiTypography fontWeight={400}>
              {"0 - Ağrı Yok , 1-2 Hafif Ağrı , 3-4 Orta Şiddetli Ağrı , > 4 Şiddetli Ağrı"}
            </ByzMuiTypography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <ByzMuiTypography fontWeight={400}>Skor : {score}</ByzMuiTypography>
          </Grid>
        </Grid>
      </ByzCard>
    </ByzCard>
  );
};

export default VisualAnalogScale;
